import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@adsk/alloy-react-checkbox';
import { useCurrentProductId, PRODUCT_IDS } from '@adsk/alloy-provider';
import { useLocale } from '@adsk/alloy-react-helpers';
import Tooltip from '@adsk/alloy-react-tooltip';
import { AlertInformationIcon } from '@adsk/alloy-react-icon';
import { useStore } from '@common/StoreProvider';
import AutoSpecsTooltip from '@common/AutoSpecsTooltip';
import {
  optionStyle,
  checkboxTextStyle,
  noPurchasedProductsTextStyle,
  productsLabelStyle,
  tooltipIconStyle,
} from './styles';

const ProductsCategory = ({
  labelText,
  noProductsText,
  onProductSelected,
  products,
  style,
  tooltipText,
}) => {
  const { state } = useStore();
  const currentProductId = useCurrentProductId();
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  return (
    <div css={style}>
      {labelText && (
        <div css={productsLabelStyle}>
          <div>{labelText}</div>
          <Tooltip shouldWrapChildren={false} content={tooltipText}>
            <AlertInformationIcon size={16} style={tooltipIconStyle} />
          </Tooltip>
        </div>
      )}
      <div>
        {products.length > 0
          ? products.map(({ type, name }) => {
              let productName = name;

              if (type === currentProductId) {
                productName = T.translate('CURRENT_PRODUCT', { product: name });
              } else if (
                type === PRODUCT_IDS.DOCS ||
                type === PRODUCT_IDS.INSIGHT
              ) {
                productName = T.translate('INCLUDED_PRODUCT', {
                  product: name,
                });
              }

              return (
                <div key={type} css={optionStyle}>
                  <Checkbox
                    data-testid={type}
                    checked={state.productsAccesses.some(
                      (value) => value === type
                    )}
                    disabled={
                      type === currentProductId ||
                      type === PRODUCT_IDS.DOCS ||
                      type === PRODUCT_IDS.INSIGHT
                    }
                    onChange={(value) =>
                      onProductSelected({ productId: type, value })
                    }
                  />
                  <div css={checkboxTextStyle}>{productName}</div>
                  {type === PRODUCT_IDS.AUTOSPECS && (
                    <AutoSpecsTooltip
                      message={T.translate('AUTOSPECS_TOOLTIP_TEXT', {
                        productName: 'Build',
                      })}
                      URLMessage={T.translate('LEARN_MORE')}
                    />
                  )}
                </div>
              );
            })
          : noProductsText && (
              <div css={noPurchasedProductsTextStyle}>{noProductsText}</div>
            )}
      </div>
    </div>
  );
};

ProductsCategory.propTypes = {
  labelText: PropTypes.string,
  noProductsText: PropTypes.string,
  onProductSelected: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      included: PropTypes.bool.isRequired,
    })
  ).isRequired,
  style: PropTypes.objectOf(PropTypes.string),
  tooltipText: PropTypes.string.isRequired,
};
ProductsCategory.defaultProps = {
  labelText: null,
  noProductsText: null,
  style: {},
};

export default ProductsCategory;
